import { useTranslation } from "react-i18next";

const features = [
  { icon: "ri-star-line", key: "review" },
  { icon: "ri-truck-line", key: "shipping" },
  { icon: "ri-coupon-3-line", key: "coupon" },
  { icon: "ri-shield-check-line", key: "safety" },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              {t("about.title")}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              {t("about.p1")}
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              {t("about.p2")}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {t("features.title")}
            </h3>
            <p className="mt-2 text-sm text-foreground-600">{t("features.subtitle")}</p>

            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {features.map((f) => (
                <div
                  key={f.key}
                  className="rounded-lg border border-foreground-200/70 bg-background-50 p-5"
                >
                  <span className="flex w-11 h-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <h4 className="mt-4 font-heading text-base font-semibold text-foreground-900">
                    {t(`features.${f.key}.title`)}
                  </h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    {t(`features.${f.key}.desc`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}